<template>
    <input-select 
    @input="v => $emit('input', v)"
    :options="options"
    :name="$trans(row.name)"
    label="label"
    :reduce="o => o.value"
    v-bind="$attrs" />
</template>

 
<script>

    import {mapState} from 'vuex'

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        },

        computed: {
            options() {
                var options = this.$trans(this.row.value)

                return _.map(options, (label, value) => {
                    return {
                        label: label,
                        value: value
                    }
                })
            }
        }

    }
</script>